<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Support
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/support/tickets"
                        >Tickets</router-link
                      ></li>
                    <li class="breadcrumb-item">Create Ticket</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="content-body ">
          <vue-element-loading :active="isLoading" :is-full-screen="true" />
          <section>
            <div class="card">
              <div
                class="card-header bg-white border-bottom_eee pt-1 px-1 mb-0 common_top_title_searchbgst_dock"
              >
                <div class="w-auto px-0 mobile-padding-0-2">
                  <div
                    class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                  >
                    <div class="avatar-content">
                      <em class="las la-ticket-alt i_icon_st font-medium-5"></em>
                    </div>
                  </div>

                  <h4 class="card-title d-inline-flex ml-0 mb-0">
                    Create Ticket
                  </h4>
                </div>
              </div>
              <div class="col-lg-12 mt-2">
                <div class="card text-center mb-1">
                  <div
                    class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
                  >
                    <div class="row">
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="ticket_type"> Ticket Type <span class="requiredField">*</span></label>
                        <treeselect placeholder="--- SELECT--- " id="ticket_type" v-model="formData.ticket_type_id" :options="query_list" />
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                        <label class="form-label text-left w-100">Subject<span class="requiredField">*</span></label>
                        <input class="form-control" v-model="formData.title" type="text" placeholder="Enter Ticket Subject"/>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="ticket_files" > Attachments</label>
                        <!-- <label for="ticket_files"  class="btn btn-relief-success mb-0 intelilinkuploadbtn form-label text-left" >Choose File</label> -->
                        <input type="file" id="ticket_files" multiple   ref="file" @change="onSelectFile($event)"/>
                      </div>
                      <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 mobileview_b_8">
                        <label class="form-label text-left w-100" for="description"> Description <span class="requiredField">*</span></label>
                        <textarea class="form-control" id="description" rows="2" v-model="formData.description" placeholder="Enter Ticket Descriptions"></textarea>
                      </div> -->

                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-1 mobileview_b_8">
                        <div class="form-group ckeditarheightview text-left">
                            <label class="form-label" for="description">Description </label>
                            <ckeditor class="ckeditarheight" id="description" :editor="editor" placeholder="Enter Ticket Description"  :config="editorConfig" tag-name="textarea" v-model="formData.description" ></ckeditor>
                        </div>
                      </div>
                      
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-right  home_das_all_buttons_style mobileview_b_8">
                          <button type="submit" class="btn btn-outline-primary mr-0 waves-effect  " :disabled="!validateForm()" @click="saveData">
                              Submit
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Quagga from "quagga";
import "vue2-datepicker/index.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Treeselect from "@riophae/vue-treeselect";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueElementLoading from "vue-element-loading";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import searchMasterNameList from "../../../utils/searchMasterNameList";
import common_methods from "../../../utils/common_methods";
import axios from "axios"

export default {
  name: "AddTicket",
  mixins: [searchMasterNameList, common_methods],
  data() {
    return {
      isLoading: false,
      query_list: [],
      formData: {
        ticket_type_id: null,
        title: null,
        description: "",
        files: null
      },
      editor: ClassicEditor,
            editorConfig: {
                
               toolbar: {
                height: 300,
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        '|',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'insertTable',
                        '|',
                        'undo',
                        'redo', '|',
                    ],
                },
            },
    };
  },
  components: {
    DatePicker,
    Treeselect,
    Loading,
    VueElementLoading,
    VueTimepicker,
    ckeditor: CKEditor.component,
  },
  mounted() {
    if (!localStorage.getItem("reloaded")) {
      localStorage.setItem("reloaded", "1");
      location.reload();
    }
    if (feather) {
      feather.replace({
        width: 14,
        height: 14,
      });
    }
    $(window).on("load", function () {
      if (feather) {
        feather.replace({
          width: 14,
          height: 14,
        });
      }
    });
  },
  created() {
    this.getDropDownData()
  },
  methods: {
    getDropDownData() {
      this.getQueryList()
    },
    getQueryList() {
      this.searchNameMasterList('query_type', 'query_name', null, 'query_id')
        .then(result => {
          this.query_list = result.data
        })
        .catch(e => {
          this.displayError(e)
        })
    },
    onSelectFile(e) {
      this.formData.files = e.target.files
    },
    resetForm() {
      let formData = this.formData
      formData.ticket_type_id = null
      formData.title = null
      formData.description = ""
      formData.files = null
    },
    validateForm() {
      let formData = this.formData
      if(!formData.ticket_type_id || !this.getTrimmedString(formData.title) || !this.getTrimmedString(formData.description)) {
        return false
      }
      return true
    },
    saveData() {
      console.log(this.formData)
      let url = "/support/tickets/add-ticket"
      if(this.formData.files) {
        var payload = new FormData();
        payload.append("files", this.formData.files);
        payload.append("folder", 'tickets')
        this.isLoading = true
        axios({
          "content-type": "multipart/form-data",
          method: "POST",
          url: "/files/s3/bulkUploadFiles",
          data: payload,
        })
        .then(result => {
          if(result.data.status) {
            let files = result.data.data
            let formPayload = this.formData
            formPayload.files = files
            this.makeRequest("POST", url, formPayload)
              .then(result => {
                this.isLoading = false
                if(result && result.data && result.data.status) {
                  this.resetForm()
                  this.sweetAlertSnackbar(result.data.message, 'success')
                } else {
                  this.sweetAlertSnackbar(result.data.message, 'error')
                }
              })
              .catch(e => {
                  this.displayError(e)
              })
          } else {
            this.sweetAlertSnackbar(result.data.message, 'error')
          }
        })
        .catch(e => {
          this.displayError(e)
        })
      } else {
        let formPayload = this.formData
        this.makeRequest("POST", url, formPayload)
          .then(result => {
            this.isLoading = false
            if(result && result.data && result.data.status) {
              this.resetForm()
              this.sweetAlertSnackbar(result.data.message, 'success')
            } else {
              this.sweetAlertSnackbar(result.data.message, 'error')
            }
          })
          .catch(e => {
              this.displayError(e)
          })
      }
      
    }
  },
};
</script>
<style>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}
.ckeditarheightview .ck.ck-powered-by{
   display: none;
}

</style>
